import { Injectable } from '@angular/core';
import { DOMStorageField, DOMStorageMap } from '../classes/dom-storage';

// prettier-ignore
@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  public readonly lastSelectedSubs =      new DOMStorageField('lastSelectedSubcontractors', localStorage);
  public readonly browserNtfBoundUserId = new DOMStorageField('BROWSER_NTF_BOUND_USER_ID',  localStorage);
  public readonly lastUsedCountries =     new DOMStorageField('LAST_USED_COUNTRY_CODES',    localStorage);

  public readonly errorLog =            new DOMStorageMap('ERROR_LOG',            localStorage);
  public readonly loginAttempts =       new DOMStorageMap('FLIKO_LOGIN_ATTEMPTS', localStorage);
  public readonly browserNtfPrompted =  new DOMStorageMap('BROWSER_NTF_PROMPTED', localStorage);
  public readonly selectedEstate =      new DOMStorageMap('SELECTED_ESTATE',      localStorage);
  public readonly selectedCompany =     new DOMStorageMap('SELECTED_COMPANY',     localStorage);
  public readonly userContext =         new DOMStorageMap('USER_CONTEXT',         localStorage);
  public readonly companyDashboardSettings = new DOMStorageMap('COMPANY_DASHBOARD_SETTINGS', localStorage);

  constructor() {}
}
